"use client";

import Image from "next/image";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface IconWithNameProps {
  src: string;
  name: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export function VehicleTypeIcon({ 
  src, 
  name, 
  size = "md",
  className 
}: IconWithNameProps) {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-12 w-12",
    lg: "h-16 w-16",
    xl: "h-20 w-20"
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn(
            "relative aspect-square rounded-lg bg-white overflow-hidden",
            sizeClasses[size],
            className
          )}>
            <Image
              src={src}
              alt={name}
              fill
              className="object-contain p-0"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{name}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}